import readRequiredStringEnv from './services/readRequiredStringEnv';

const defaultLocale: string = readRequiredStringEnv(
  process.env.NEXT_PUBLIC_DEFAULT_LOCALE,
  'NEXT_PUBLIC_DEFAULT_LOCALE'
);
export default defaultLocale;
